module.exports = __WEBPACK_EXTERNAL_MODULE_webcom_webcom__;